import { render, staticRenderFns } from "./incident-impact-selector.vue?vue&type=template&id=c074a126&"
import script from "./incident-impact-selector.vue?vue&type=script&lang=js&"
export * from "./incident-impact-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports